import { Injectable, Injector } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { tap } from 'rxjs/operators';
import { AuthService } from '@/app/auth.service';
import { UserActionsTypes } from '@/app/_infrastructure/adapters/store/user/user.actions';
import { ActivatedRoute, Router } from '@angular/router';
import { LoginViewComponent } from '@/app/login/login-view.component';

@Injectable()
export class UserEffects {
  logoutUser$ = createEffect(
    () =>
      this.actions$.pipe(
        ofType(UserActionsTypes.DeleteUser),
        tap((action) => {
          const authService = this.injector.get(AuthService);
          authService.navigateToLogoutRoute();
        })
      ),
    { dispatch: false }
  );

  loginUser$ = createEffect(
    () =>
      this.actions$.pipe(
        ofType(UserActionsTypes.SetUser),
        tap((action) => {
          const authService = this.injector.get(AuthService);
          if (location.href.endsWith('/login') || location.href.endsWith('/cert-login')) {
            this.router.navigate(['mainView']);
          }
        })
      ),
    { dispatch: false }
  );

  constructor(
    private actions$: Actions,
    private injector: Injector,
    private router: Router
  ) {}
}
